import type { TeamCapability } from '@aegislab/shared';
import { getViewState, liveWindowSize, teaserWindowSize, type WindowConfig } from '@/shared/config';
import { ViewGate } from './windowRegistryComponents';
import { lazyWindow } from './lazyWindow';

const UsageDashboardPage = lazyWindow('사용량', () =>
  import('@/pages/UsageDashboardPage').then((m) => ({ default: m.UsageDashboardPage }))
);

/**
 * 사용량 창 — `DEV` capability 팀과 EXECUTIVE 에게 열린다(Q03 ②). 별도 자격이 없어
 * 개발 퀘스트 창과 같은 모양으로 `ViewGate` 만 둔다. `windowRegistry.tsx` 가 길이 한도에 닿아 따로 뒀다.
 */
export function buildUsageDashboardWindow(teamCapabilities: TeamCapability[]): WindowConfig {
  const state = getViewState('usage-dashboard', teamCapabilities);
  return {
    id: 'usage-dashboard',
    title: state !== 'live' ? '[DECRYPTING...]' : '사용량',
    defaultX: 140,
    defaultY: 40,
    ...(state !== 'live' ? teaserWindowSize : liveWindowSize.standard),
    render: () => (
      <ViewGate viewId="usage-dashboard" viewLabel="사용량">
        <UsageDashboardPage />
      </ViewGate>
    ),
  };
}
